import {Injectable} from "@angular/core";
import {AuthApiService} from "../auth/auth-api.service";
import {BatchJobData} from "./batch-job.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {AppPaymentAccountData} from "../app-payment-account/app-payment-account.data";

@Injectable()
export class BatchJobService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }


    async uploadFile(type: string, file: File): Promise<void> {
        const formData: FormData = new FormData();
        formData.append("uploadedFileName", file);
        return firstValueFrom(this.http.post<void>("/fonzie/batch-job-upload/" + type, formData, {headers: this.auth.getHttpHeaderOptionsForFile()}));
    }

    async getBatchJobs(type: string): Promise<BatchJobData[]> {
        return firstValueFrom(this.http.get<BatchJobData[]>("/fonzie/batch-job/" + type, {headers: this.auth.getHttpHeaderOptions()}));
    }

}
